import { Typography } from "@mui/material";

export default function PointDetailArray({ property, location }) {
  if (property.type !== "array") return <></>;
  if (!location[property.key] || location[property.key].length === 0)
    return <></>;

  return (
    <>
      <Typography variant="body1" className="title">
        {property.label}
      </Typography>
      <Typography variant="body1" className="value" sx={{ mb: 1 }}>
        {location[property.key].map((p) => p.name ?? p.title).join(", ")}
      </Typography>
    </>
  );
}
